export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6940.a0c97ccb.jpg";